function getEnumValue<T>(
  enumObject: T,
  key: string | undefined
): T[keyof T] | undefined {
  if (!key) return undefined
  return enumObject[key as keyof T]
}

function getEnumKeyByValue<T extends Record<string, string>>(
  enumObject: T,
  value: string
): keyof T | undefined {
  return Object.keys(enumObject).find(
    (key) => enumObject[key as keyof T] === value
  ) as keyof T | undefined
}

function getEnumValueByValue<T extends Record<string, string>>(
  enumObject: T,
  value: string
): T[keyof T] | undefined {
  const key = getEnumKeyByValue(enumObject, value)
  return key ? enumObject[key] : undefined
}

export { getEnumValue, getEnumKeyByValue, getEnumValueByValue }
